<template>
  <Public class="tw-h-screen">
    <v-main>
      <about></about>
      <feature></feature>
      <supported-ecommerce-list></supported-ecommerce-list>
      <supported-program-list></supported-program-list>
      <!-- <customers-opinion></customers-opinion> -->
      <lead-footer></lead-footer>
      <contact></contact>
      <footer-web></footer-web>
    </v-main>
  </Public>
</template>

<script>
import Public from '@/components/public/public-main-template'
import About from '@/components/public/home/about'
import Feature from '@/components/public/home/feature'
import SupportedEcommerceList from '@/components/public/home/supported-ecommerce-list'
import SupportedProgramList from '@/components/public/home/supported-program-list'
// import CustomersOpinion from '@/components/public/home/customers-opinion'
import FooterWeb from '@/components/public/footer'
import LeadFooter from '@/components/public/home/lead-footer.vue'
import Contact from '@/components/public/home/contact.vue'

export default {
  name: 'Home',
  components: {
    Public,
    About,
    Feature,
    SupportedEcommerceList,
    SupportedProgramList,
    // CustomersOpinion,
    FooterWeb,
    LeadFooter,
    Contact
  }
}
</script>

<style lang="scss">

strong {
  color: #c9242b;
}

</style>
